import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'util/checks'

import { ConsultaSeguimentoPergunta12Model } from './model-consultaSeguimentoPergunta12'
import {
  hasPergunta12ExemplosAtLeastTwoSim,
  hasPergunta12ExemplosFalhouAnySim,
  hasPergunta12ExemplosPassouAnySim,
  isPergunta12ExemplosAllFilled,
  isPergunta12ExemplosPassouFalhouAllFilled,
  isPergunta12ExemplosPassouFalhouAllNao,
} from './utils-consultaSeguimentoPergunta12'

export const PERGUNTA_12_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta12Model> = {
  PERGUNTA_12_HEADER: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_12_EXEMPLOS',
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
  },
  PERGUNTA_12_EXEMPLOS: {
    scrollConditions: [
      {
        if: (_, allValues) => hasPergunta12ExemplosAtLeastTwoSim(allValues),
        scrollTo: 'PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU',
      },
      {
        if: (_, allValues) =>
          isPergunta12ExemplosAllFilled(allValues) && !hasPergunta12ExemplosAtLeastTwoSim(allValues),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_12_HEADER',
  },
  PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU: {
    scrollConditions: [
      {
        if: (value) =>
          isPergunta12ExemplosPassouFalhouAllFilled(value) &&
          hasPergunta12ExemplosPassouAnySim(value) &&
          hasPergunta12ExemplosFalhouAnySim(value),
        scrollTo: 'PERGUNTA_12_FREQUENCIA',
      },
      {
        if: (value) =>
          isPergunta12ExemplosPassouFalhouAllFilled(value) &&
          hasPergunta12ExemplosPassouAnySim(value) &&
          !hasPergunta12ExemplosFalhouAnySim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) =>
          isPergunta12ExemplosPassouFalhouAllFilled(value) &&
          hasPergunta12ExemplosFalhouAnySim(value) &&
          !hasPergunta12ExemplosPassouAnySim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => isPergunta12ExemplosPassouFalhouAllNao(value),
        scrollTo: 'BOTTOM',
      },
    ],
    dependsOn: 'PERGUNTA_12_EXEMPLOS',
  },
  PERGUNTA_12_FREQUENCIA: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU',
  },
}
